import styled from 'styled-components';

// Libs
import {lib} from '@drivesally/sally-ui';

// Colors
const {
  colors: {orange},
} = lib;

const Container = styled.div`
  width: 100%;
  height: 200px;
  font-size: 20px;
  color: ${orange};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export default Container;
